import { Text } from "@simplybusiness/mobius";
import { errorState, successState } from "../values";
import { PhoneNumber } from "../PhoneNumber";
import { TransferReference } from "../TransferReference";
import { header } from "../Header";

const text = {
  consentNotGiven: {
    header: "Transfer not completed",
    body: `Your details have not been passed to Gallagher, if you need any 
      further help call us on `,
    phone_number: "0330 912 0297",
  },
};

export interface TransferResultMessageUKProps {
  transferStatus: {
    state: string;
    response: {
      reference: string;
    };
  };
}

export const TransferResultMessageUK = ({
  transferStatus,
}: TransferResultMessageUKProps) => {
  function Message() {
    const transferReferenceCopy = `Here is your unique customer reference number for Gallagher: `;

    switch (transferStatus.state) {
      case successState:
        return (
          <>
            <Text>
              {`Great, Gallagher will be in touch as soon as possible
            within their working hours. You can also contact them on `}
              {PhoneNumber("01443 807415")}
              {` between 9am-5pm, Monday to Friday.`}
            </Text>
            <Text>
              {transferReferenceCopy}
              {TransferReference(transferStatus)}
            </Text>
          </>
        );
      case errorState:
        return (
          <>
            <Text>
              {`Unfortunately, we've been unable to pass your details over 
          at this time but we'll try our best to pass on your information to Gallagher. 
          If you'd like to speak with them, you can call on `}
              {PhoneNumber("01443 807415")}
              {` between 9am-5pm, Monday to Friday.`}
            </Text>
            <Text>
              {transferReferenceCopy}
              {TransferReference(transferStatus)}
            </Text>
          </>
        );
      default:
        return (
          <Text>
            {text.consentNotGiven.body}
            {PhoneNumber(text.consentNotGiven.phone_number)}
          </Text>
        );
    }
  }

  return (
    <div>
      <Text elementType="h2">{header(transferStatus, text)}</Text>
      <Message />
    </div>
  );
};
